import { render, staticRenderFns } from "./ItemFirstVideo.vue?vue&type=template&id=4af2bfa2&"
import script from "./ItemFirstVideo.vue?vue&type=script&lang=js&"
export * from "./ItemFirstVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ItemFirstVideo.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports